import axios, {AxiosResponse} from "axios";
import {Cache} from "./Cache"
import {GeolocationApiResponse} from "@/models/GeolocationModel";
import {configuration} from "@/composables/ConfigurationComposition";

const geolocationCache = new Cache<string>();

/**
 * fetch browser location country code from geoapify by lat and lng
 *
 * @param lat
 * @param lng
 */
export function fetchBrowserlocation(lat: number, lng: number) {
    const key = configuration.geoapifyKey;
    const lang = configuration.geoapifyLang;
    const url = `https://api.geoapify.com/v1/geocode/reverse?lat=${lat}&lon=${lng}&lang=${lang}&apiKey=${key}&type=country`;
    const cachedData = geolocationCache.get(url);

    return new Promise<string>((resolve) => {
        if (cachedData !== undefined) {
            resolve(cachedData);
        } else {
            axios
                .get(url)
                .then((response: AxiosResponse<GeolocationApiResponse>) => {
                    const countryCode = response.data.features[0].properties.country_code;

                    geolocationCache.set(url, countryCode);

                    resolve(`${countryCode}`);
                })
                .catch(e => {
                    resolve('');
                });
        }
    });
}

